import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "../../../common/api/apiShared";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { IDeleteAreaDialog } from "./DeleteAreaDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useDeleteAreaDialogHooks(props: IDeleteAreaDialog) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeArea = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: any) => {
                props.onCloseDialog();

                if (response.success()) {
                    props.onDeleted();
                    snackbar.show(createElement(Trans, { i18nKey: "dataDeleted", values: { name: props.selectedArea.name } }));
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "areaNotDeleted", values: { name: props.selectedArea.name } }), "warning");
                }
            },
        });
    };

    async function remove() {
        return await deleteHttp<{}>(`/areas/${props.selectedArea.id}`);
    }

    return {
        removeArea,
        inProgess: removeMutation.isLoading,
    };
}
